export class solicitud{
    constructor(){

    }
}